import { Component, OnInit } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';

import { ApContentService } from '@ap/content';
import { Bank } from '@ap/interface-bspc-core';
import { ActieveConfiguratie } from '@ap/interface-apic-kanaalconfiguratie-beheer';
import { HttpResponse } from '@ap/interface-generic';
import { SignToken } from '@ap/sign';
import { TaskStatus } from '@ap/interface-apic-authenticatiebeheer';
import { ApThemeService } from '@ap/theme';

import { KantoorSignService } from './kantoor-sign.service';
import { LoginNotification } from './kantoor-sign.model';
import { Type } from './PdfModel';
import content from './kantoor-sign.content.json';

/**
 * @ngdoc component
 * @name KantoorSignComponent
 * @module KantoorSignModule
 */
@Component({
    selector: 'kantoor-sign',
    templateUrl: './kantoor-sign.component.html',
    standalone: false
})
export class KantoorSignComponent implements OnInit {
    public token: SignToken = SignToken.NATIVE_APP;
    public actionId: string;
    public signError = false;
    public activeChannelConfiguration$: Observable<LoginNotification>;

    public qAndAType = Type.Q_AND_A;
    public stappenplanType = Type.STAPPENPLAN;
    private readonly pdf = '.pdf';
    private readonly assets = 'assets/';

    public readonly taskstatus = TaskStatus.UNAUTHENTICATED_EXPIRED;

    public constructor(
        private kantoorSignService: KantoorSignService,
        private readonly contentService: ApContentService,
        private readonly themeService: ApThemeService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.kantoorSignService.isAlreadyLoggedIn().subscribe((loggedIn) => {
            if (loggedIn) {
                this.kantoorSignService.navigateToMijnKantoor();
            } else {
                this.setActionId();
            }
        });
        const bank: Bank = this.kantoorSignService.getBank();
        this.activeChannelConfiguration$ = this.kantoorSignService.getActiveChannelConfiguration(bank).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status !== HttpResponse.OK) {
                    return of({});
                }
                return throwError(err);
            }),
            map((actieveConfiguratie: ActieveConfiguratie) => JSON.parse(actieveConfiguratie.waarde))
        );
    }

    public setActionId(): void {
        this.kantoorSignService.getActionId().subscribe((actionId) => {
            if (actionId) {
                this.actionId = actionId;
            } else {
                this.error();
            }
        });
    }

    public complete(): void {
        this.kantoorSignService.startSession(this.actionId).subscribe(() => {
            this.kantoorSignService.navigateToMijnKantoor();
        });
    }

    public error(): void {
        this.signError = true;
    }

    public downloadPdf(type: Type): void {
        const link = document.createElement('a');
        link.download = type.toString() + this.pdf;
        link.href = this.assets + type + this.pdf;
        link.click();
    }

    public showProblemsLogin(): boolean {
        return this.themeService.getTheme() === 'blg';
    }
}
